import * as types from '../actionTypes/Room'

export const setRoomName = payload => ({
    type: types.SET_ROOM_NAME,
    payload,
})

export const setRoomState = payload => ({
    type: types.SET_ROOM_STATE,
    payload,
})

export const setMaster = payload => ({
    type: types.SET_MASTER,
    payload,
})

export const handleSetIsSpeaking = ({ isSpeaking, volume }) => ({
    type: types.HANDLE_SET_IS_SPEAKING,
    isSpeaking,
    volume,
})

export const setIsSpeaking = isSpeaking => ({
    type: types.SET_IS_SPEAKING,
    isSpeaking,
})

export const setStudentsCount = studentsCount => ({
    type: types.SET_STUDENTS_COUNT,
    studentsCount,
})

export const setRecordingAlert = alert => ({
    type: types.SET_RECORDING_ALERT,
    alert,
})

export const setIsInteractionMode = isInteractionMode => ({
    type: types.SET_IS_INTERACTION_MODE,
    isInteractionMode,
})

export const setTwilioToken = payload => ({
    type: types.SET_TWILIO_TOKEN,
    payload,
})

export const setIsRoomLoading = payload => ({
    type: types.SET_IS_ROOM_LOADING,
    payload,
})

export const setClassTitleAndRoomType = payload => ({
    type: types.SET_CLASS_TITLE_AND_ROOM_TYPE,
    payload,
})

export const handlePIP = (enabled = false) => ({
    type: types.HANDLE_PIP,
    enabled,
})

export const handleRoomState = room => ({
    type: types.HANDLE_ROOM_STATE,
    room,
})

export const setParticipant = participant => ({
    type: types.SET_PARTICIPANT,
    participant,
})

export const updateParticipantInfo = (id, infoKey, infoValue) => ({
    type: types.UPDATE_PARTICIPANT_INFO,
    id,
    infoKey,
    infoValue,
})

export const setRemoteParticipants = participants => ({
    type: types.SET_REMOTE_PARTICIPANTS,
    participants,
})

export const removeParticipant = participant => ({
    type: types.REMOVE_PARTICIPANT,
    participant,
})

export const updateDominantSpeaker = value => ({
    type: types.UPDATE_DOMINANT_SPEAKER,
    value,
})

export const handleFullScreenToggle = isTeacherFullScreen => ({
    type: types.HANDLE_FULL_SCREEN_TOGGLE,
    isTeacherFullScreen,
})

export const setDisconnectedParticipant = participant => ({
    type: types.UPDATE_DISCONNECTED_PARTICIPANT,
    data: participant,
})

export const setConnectedParticipant = participant => ({
    type: types.UPDATE_CONNECTED_PARTICIPANT,
    data: participant,
})

export const updateNetworkBandwidthSaverMode = value => ({
    type: types.UPDATE_NETWORK_BANDWIDTH_SAVER_MODE,
    value,
})

export const updateIsTeacherPresent = value => ({
    type: types.UPDATE_IS_TEACHER_PRESENT,
    value,
})

export const updateIsActivityMode = value => ({
    type: types.UPDATE_IS_ACTIVITY_MODE,
    value,
})
